<template>
  <div
    id="stats"
    class="relative flex flex-col justify-start items-center py-16 px-4 bg-summon-section bg-no-repeat bg-cover overflow-hidden"
  >
    <section-title titlePath="title-8.png" />
    <div class="btns flex flex-row justify-center w-full mb-5">
      <div
        v-for="(menu, index) in menuData"
        :key="index"
        :class="{ menuActive: menu.isActive }"
        class="cursor-pointer w-158 h-54 m-3 text-white font-elmessiri text-xl flex justify-center items-center bg-cover bg-center bg-btn-off"
        @click="handleMenu(index)"
      >
        {{ menu.text }}
      </div>
    </div>
    <transition-group
      name="fade"
      tag="div"
      :class="menuData[0].isActive ? 'h-590' : 'h-832'"
      class="relative w-full flex justify-center items-start"
    >
      <div
        v-show="menuData[0].isActive"
        class="absolute w-full h-464 flex flex-col items-center"
        :key="menuData[0].text"
      >
        <div class="w-full">
          <img :src="`${imgPath}/slide9/img_runestones.png`" />
        </div>
        <div class="font-nunito text-grayish-orange text-center px-5">
          Customize your character like never before with the aspirational
          Runestones and Memorials.
          <br />
          Runestones are magical stones that provide additional stat boosts
          based on your chosen class. You can have up to 5 Runestones active,
          with more available Runestones being unlocked as you level up.
          <br />
          Each of your Runestones is randomly chosen from a pool of up to 30
          possible Runestone types, with each type providing its own special
          benefit; if you are unhappy with your Runestone type selection,<br />
          you can re-roll all of them at any time for a Runestone Scroll
          purchased from NPC Rohan or flash sales.
        </div>
      </div>
      <div
        v-show="menuData[1].isActive"
        class="absolute w-full max-w-810 flex flex-col items-center"
        :key="menuData[1].text"
      >
        <div class="w-full justify-center items-center">
          <img :src="`${imgPath}/slide9/img_memorials.png`" />
        </div>
        <div class="w-full bg-black bg-opacity-70 py-4 px-3">
          <div
            v-for="(memorial, index) in memorialData"
            :key="index"
            class="flex flex-row mt-2"
          >
            <span
              :style="{ background: memorial.color }"
              class="text-white font-bold w-7 h-7 flex justify-center items-center mr-2"
              v-html="memorial.number"
            ></span>
            <p
              class="w-full max-w-300 text-grayish-orange text-sm"
              v-html="memorial.desc"
            ></p>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import breakpoints from '@/plugins/breakpoints';
import SectionTitle from '../components/SectionTitle/SectionTitle';
export default {
  components: {
    SectionTitle,
  },
  data: function() {
    return {
      breakpoints,
      imgPath: process.env.VUE_APP_IMG_URL,
      menuData: [
        {
          text: 'Runestones',
          isActive: false,
        },
        {
          text: 'Memorials',
          isActive: true,
        },
      ],
      memorialData: [
        {
          color: '#B033E3',
          number: 'A',
          desc:
            'Memorial Save Page<br/>• Allows each memorial to be saved.<br/>• Only the activated page will be in effect.<br/>• Page switch cooldown time is 30 seconds.',
        },
        {
          color: '#F6AC09',
          number: 'B',
          desc:
            'Mission of the Day<br/>• Can acquire Hero Fragments by completing missions.<br/>• When cleared, it will proceed to the next stage.',
        },
        {
          color: '#69D404',
          number: 'C',
          desc:
            'Mission of the Day<br/>• Can acquire Hero Fragments by completing missions.<br/>• When cleared, it will proceed to the next stage.',
        },
        {
          color: '#de2120',
          number: 'D',
          desc:
            'Memorial Pieces<br/>•There are 4 memorials with 9 pieces in each memorial.<br/>• A piece can be unlocked using a hero fragment, and a random stat is given.<br/>• If all 9 pieces are unlocked, a random set effect is given.<br/>• Memorial effects can be reset using a hero fragment and a Memorial Reset Crystal.<br/>',
        },
        {
          color: '#0190fd',
          number: 'E',
          desc:
            'Memorial Effects<br/>•Shows the acquired stats from the memorials.',
        },
      ],
    };
  },
  methods: {
    handleMenu: function(menuIndex) {
      for (let i = 0; i < this.menuData.length; i++) {
        if (menuIndex === i) {
          this.menuData[i].isActive = true;
        } else {
          this.menuData[i].isActive = false;
        }
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.btns .menuActive {
  @apply bg-btn-on;
}
</style>
